import React from 'react'
import "./SubStyle.css"

const Acc_Endof = () => {
  return (
     <section className="SubServices">
     <h1 className="SubServices-title">End of Year Accounts</h1>
      <p className="SubServices-pera">Ensure your annual accounts are prepared accurately and submitted on time. We provide clear, compliant financial statements that help you understand your business performance and meet all reporting requirements with confidence.</p>
         <div className="btn-container">
        <button className="SubServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default Acc_Endof
